
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/all_blog",
      function () {
        return require("private-next-pages/blogs/all_blog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/all_blog"])
      });
    }
  